var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRand = function SvgRand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.056,
    cy: 21.125,
    r: 20.207,
    fill: "#D4D4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.492 30.726a1.08 1.08 0 0 1-1.08-1.08V12.194c0-.597.484-1.08 1.08-1.08h5.911c1.52 0 2.78.261 3.783.785 1.009.523 1.762 1.248 2.26 2.174.498.92.747 1.982.747 3.189 0 1.2-.252 2.257-.757 3.17-.498.906-1.251 1.612-2.26 2.116-1.002.504-2.263.757-3.783.757h-4.215a1.08 1.08 0 0 1-1.08-1.08v-.388c0-.596.483-1.08 1.08-1.08h3.947c.958 0 1.737-.137 2.337-.412.607-.274 1.05-.673 1.331-1.197.281-.523.422-1.152.422-1.886 0-.74-.144-1.382-.431-1.925-.281-.543-.725-.958-1.332-1.245-.6-.294-1.388-.44-2.365-.44h-2.636a1.08 1.08 0 0 0-1.08 1.08v14.914a1.08 1.08 0 0 1-1.08 1.08h-.799Zm7.962-8.848c.395 0 .758.215.947.561l3.663 6.689a1.08 1.08 0 0 1-.947 1.598h-.902a1.08 1.08 0 0 1-.952-.569l-3.59-6.689a1.08 1.08 0 0 1 .951-1.59h.83Z",
    fill: "#fff"
  })));
};
export default SvgRand;